<template>
  <div class="offset">
    <scheme-tree-view></scheme-tree-view>
  </div>
</template>

<script>
// @ is an alias to /src
import SchemeTreeView from '@/components/coach/scheme/SchemeTreeView.vue';

export default {
  components: {
    SchemeTreeView,
  },
};
</script>
